import {API} from 'api';
import {JobsAPI} from 'api/jobs';
import {SeoLinksAPI} from 'api/seo_links';
import {TrackingAPI} from 'api/tracking';
import {JobList} from 'components/jobs';
import {MetaTags} from 'components/seo';
import {GetServerSideProps} from 'next';
import {Params} from 'next/dist/server/router';
import {useEffect} from 'react';
import {IQPage} from 'types/page';

const SeoJobListPage: IQPage<Props> = ({
  jobs,
  promotedJobs,
  searchSummary,
  jobsFilter,
  seoLink,
}) => {
  useEffect(() => {
    TrackingAPI.jobBoardViewed();
  }, []);

  return (
    <main>
      <MetaTags title='Jobs' />
      <JobList
        jobs={jobs}
        promotedJobs={promotedJobs}
        searchSummary={searchSummary}
        jobsFilter={jobsFilter}
        seoLink={seoLink}
      />
    </main>
  );
};

export default SeoJobListPage;

type Props = {
  seoLink: SeoLink;
  jobs: Job[];
  promotedJobs: Job[];
  searchSummary: SearchSummary;
  jobsFilter: JobsFilters;
};

export const getServerSideProps: GetServerSideProps<Props, Params> = async (context) => {
  const {slug} = context.params;
  const {cookie} = context.req.headers;

  const seoLink = await SeoLinksAPI.getSeoLinkFromSlug(slug as string, 'job');
  if ((seoLink as any).error) {
    return {notFound: true};
  }

  const jobsResponsePromise = API.withCookie(cookie, async () =>
    JobsAPI.getJobs(seoLink.url.replace('/jobs?', '')),
  );
  const jobsFiltersPromise = JobsAPI.getJobFilters();

  const [jobsResponse, jobsFilters] = await Promise.all([jobsResponsePromise, jobsFiltersPromise]);

  return {
    props: {
      jobs: jobsResponse.jobs,
      promotedJobs: jobsResponse.promoted_jobs,
      searchSummary: jobsResponse.search_summary,
      jobsFilter: jobsFilters,
      seoLink: seoLink,
    },
  };
};
